(function () {
  'use strict';

  /* ── Slide the upsell scroll strip ── */
  function bxSlide(dir) {
    var scroll = document.getElementById('bxScroll');
    if (!scroll) return;
    var card = scroll.querySelector('.bx-us-card');
    var step = card ? (card.offsetWidth + 10) : 158;
    scroll.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  /* ── Keep prev/next arrows in sync with scroll position ── */
  function wireScrollSync() {
    var scroll = document.getElementById('bxScroll');
    var prev   = document.getElementById('bxPrev');
    var next   = document.getElementById('bxNext');
    if (!scroll || !prev || !next) return;

    if (scroll._bxSync) scroll.removeEventListener('scroll', scroll._bxSync);

    function syncNav() {
      prev.disabled = scroll.scrollLeft <= 4;
      next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 4;
    }
    scroll._bxSync = syncNav;
    scroll.addEventListener('scroll', syncNav, { passive: true });
    syncNav();
  }

  /* ── Add to cart ── */
  function bxAddToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var productId = btn.getAttribute('data-product-id');
    if (!variantId) return;

    var sectionIds = [];
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid) sectionIds.push(sid);
    });

    btn.classList.add('bx-us-add--loading');
    btn.textContent = '…';

    var body = { id: parseInt(variantId, 10), quantity: 1 };
    if (sectionIds.length) body.sections = sectionIds.join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (response.status === 422 || response.description) {
        btn.classList.remove('bx-us-add--loading');
        btn.textContent = '+ Add';
        console.warn('[bxCart]', response.description || response);
        return;
      }

      bxSetProductState(productId, true);

      if (typeof window.manualCartRefresh === 'function') {
        window.manualCartRefresh(response);
      }

      var detail = { bubbles: true, detail: response };
      document.dispatchEvent(new CustomEvent('cart:updated', detail));
      document.dispatchEvent(new CustomEvent('cart:refresh', detail));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', detail));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', detail));
    })
    .catch(function (err) {
      console.error('[bxCart] Add error:', err);
      btn.classList.remove('bx-us-add--loading');
      btn.textContent = '+ Add';
    });
  }

  function bxSetProductState(productId, added) {
    document.querySelectorAll('.bx-us-add[data-product-id="' + productId + '"]')
      .forEach(function (b) {
        b.classList.toggle('bx-us-add--added', added);
        b.classList.remove('bx-us-add--loading');
        b.textContent = added ? '✓ Added' : '+ Add';
      });
  }

  /* ── Re-sync all button states from live cart ── */
  function bxSyncButtons() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCartIds = cart.items.map(function (i) { return String(i.product_id); });
        document.querySelectorAll('.bx-us-add').forEach(function (b) {
          var added = inCartIds.indexOf(b.getAttribute('data-product-id')) !== -1;
          b.classList.toggle('bx-us-add--added', added);
          b.classList.remove('bx-us-add--loading');
          b.textContent = added ? '✓ Added' : '+ Add';
        });
      })
      .catch(function () {});
  }

  /* ── Single click handler on document in CAPTURE phase ──
     capture:true fires before any stopPropagation in cart drawer code ── */
  function bxClickHandler(e) {
    var target = e.target;
    if (!target.closest) return;

    if (target.closest('#bxPrev')) { bxSlide(-1); return; }
    if (target.closest('#bxNext')) { bxSlide(1);  return; }

    var btn = target.closest('.bx-us-add');
    if (!btn) return;
    if (btn.classList.contains('bx-us-add--added') ||
        btn.classList.contains('bx-us-add--loading')) return;
    bxAddToCart(btn);
  }

  /* ── After every cart re-render, re-wire scroll and sync buttons ── */
  function bxOnCartUpdate() {
    setTimeout(function () {
      wireScrollSync();
      bxSyncButtons();
    }, 450);
  }

  /* ── MutationObserver: catches async cart drawer renders ──
     Fires wireScrollSync the moment #bxScroll appears in DOM ── */
  if (!window._bxObserver) {
    window._bxObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var nodes = mutations[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var node = nodes[j];
          if (node.nodeType !== 1) continue;
          if (
            node.id === 'bxScroll' ||
            node.id === 'bxUpsellWrap' ||
            (node.querySelector && node.querySelector('#bxScroll'))
          ) {
            wireScrollSync();
            bxSyncButtons();
            return;
          }
        }
      }
    });
    window._bxObserver.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  /* ── Register listeners once, remove old ones first ── */
  document.removeEventListener('click', window._bxClickHandler, true);
  window._bxClickHandler = bxClickHandler;
  document.addEventListener('click', window._bxClickHandler, true);

  var cartEvents = [
    'cart:updated',
    'cart:refresh',
    'sections:updated',
    'dispatch:cart-drawer:refresh'
  ];

  if (window._bxOnCartUpdate) {
    cartEvents.forEach(function (evt) {
      document.removeEventListener(evt, window._bxOnCartUpdate);
    });
  }
  window._bxOnCartUpdate = bxOnCartUpdate;
  cartEvents.forEach(function (evt) {
    document.addEventListener(evt, window._bxOnCartUpdate);
  });

  /* ── Boot ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireScrollSync);
  } else {
    wireScrollSync();
  }

})();